<template>
  <div>
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Satisfação do cidadão"
            description="Satisfação da pessoa atendida pela eSB"
            url="/indicadores-esb/ampliados"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="maintenance">
            <i class="icofont-tools"></i>
            <h2>Em construção...</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'SatisfacaodoCidadao',
  components: {
    SectionTitle,
  },

  data() {
    return {}
  },
}
</script>

<style></style>
